class SearchRequest {
	constructor() {
		this.request = {};
		this.request = this._deparam(window.location.search);
		// console.log(5, this.request, window.location.search);
	}

	clearFilterByTreeId(treeId) {
		try {
			delete this.request.filter[treeId];
		} catch (err) {
		}
	}

	setModule(module) {
		this.setByKeyValue('module', module)
		this.request.module = module;
	}

	setPage(page) {
		this.request.page = page;
	}

	setLimit(limit) {
		this.request.limit = limit;
	}

	setSort(sort) {
		this.request.order = sort;
	}

	setAmountPerPage(perPage) {
		this.request.limit = perPage;
	}

	setByKeyValue(key, value) {
		this.request[key] = value;
	}

	clearByKey(key) {
		try {
			delete this.request[key];
		} catch (err) {
		}
	}

	setDateByKey(key, date) {
		if (date instanceof Date) {
			date = (this._dateToString(date));
		}
		this.setByKeyValue(key, date);
	}

	hasFilterGroup(treeId) {
		if (!this.request.hasOwnProperty('filter')) {
			return false;
		}
		if (this.request.filter.hasOwnProperty(treeId)) {
			return true;
		}

	}

	hasFilter(treeId, id) {
		if (this.hasFilterGroup(treeId)) {
			return this.request.filter[treeId].hasOwnProperty(id);
		}
		return false;
	}

	clearFilter(treeId, id) {
		if (!this.hasFilter(treeId, id)) return;
		delete this.request.filter[treeId][id]
	}

	addFilter(treeId, filterId, filterTitle) {
		if (!this.request.hasOwnProperty('filter'))
			this.request.filter = {};
		if (!this.request.filter.hasOwnProperty(treeId))
			this.request.filter[treeId] = {}

		this.request.filter[treeId][filterId] = filterTitle;
	}

	doCountRequest(callback) {
		jQuery.get('?count=1&search=' + btoa(JSON.stringify(this.request)), callback);
	}

	async doRequest() {
		await jQuery.get(window.location.pathname, this.request, this.handleResponse);
		try {
			delete this.request.module;
		} catch (e) {
		}
		history.pushState(this.request, 'step', window.location.pathname + '?' + jQuery.param(this.request));
		return false;
	}

	handleResponse(response) {
		console.error('Geen callback gedefineerd');
	}

	_dateToString(date) {
		let month = ("0" + (date.getMonth() + 1)).slice(-2);
		let day = ("0" + (date.getDate())).slice(-2);
		return date.getFullYear() + '-' + month + '-' + day;
	}

	_deparam(query) {
		function addValue(obj, keys, value) {
			let entry = keys.shift();
			let key = entry.replace(/\[/, '').replace(/\]/, '');
			if (keys.length > 0) {
				if (typeof obj[key] == 'undefined') {
					obj[key] = {};
				}
				addValue(obj[key], keys, value)
			} else {
				obj[key] = value;
			}
		}

		if (query == '') return {};
		query = query.replace(/^\?/, '');
		var hash = {};
		var vars = query.split("&");
		for (var i = 0; i < vars.length; i++) {
			var pair = vars[i].split("=");
			var k = decodeURIComponent(pair[0]);
			var v = decodeURIComponent(pair[1]);      // If it is the first entry with this name
			let matches = k.match(/\[(.*?)\]/g);
			let matches2 = k.match(/([A-z]+)\[\]/);

			if(matches2 && matches2.length > 0) {
				if(typeof hash[matches2[1]] == 'undefined') {
					hash[matches2[1]] = [];
				}
				hash[matches2[1]].push(v);
			} else if(matches && matches.length > 0) {
				let realKey = k.match(/^[a-zA-Z0-9]+/);
				if (typeof hash[realKey[0]] == 'undefined') {
					hash[realKey[0]] = {};
				}
				addValue(hash[realKey[0]], matches, v)
			} else {
				hash[k] = v;
			}

		}
		return hash;
	}

}


export default new SearchRequest();